import React from 'react';

function WelcomeMap(props) {
    return (
        <div className="container">
            <div className="m-2 " style={{ textAlign: "left" }}>
                <h3 style={{ textAlign: "center" }}>
                    이메일주소무단수집거부
                </h3>
                본 홈페이지에 게시된 이메일 주소가 전자우편 수집 프로그램이나 그 밖의 기술적 방법을 이용하여 무단으로 수집되는 것을 거부하며, 이를 위반 할 시에는 정보통신망법에 의해 형사 처벌됨을 유념하시기 바랍니다.
                <br></br>
                <br></br>
                정보통신망법 제 50조의 2(전자우편주소의 무단 수집행위 등 금지)
                <br></br>
                <br></br>
                ① 누구든지 인터넷 홈페이지 운영자 또는 관리자의 사전 동의 없이 인터넷 홈페이지에서 자동으로 전자우편주소를 수집하는 프로그램이나 그 밖의 기술적 장치를 이용하여 전자우편주소를 수집하여서는 아니 된다.
                <br></br>
                ② 누구든지 제1항을 위반하여 수집된 전자우편주소를 판매·유통하여서는 아니 된다.
                <br></br>
                ③ 누구든지 제1항과 제2항에 따라 수집·판매 및 유통이 금지된 전자우편주소임을 알면서 이를 정보 전송에 이용 하여서는 아니 된다.
            </div>
        </div>
    );
}

export default WelcomeMap;